import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
let PhoneNumber = class PhoneNumber extends Vue {
  // eslint-disable-next-line
  watchIndex() {}
  dataChage(value) {
    console.log("item---", value);
  }
};
__decorate([Prop({
  type: Number,
  default: {}
})], PhoneNumber.prototype, "zIndex", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})], PhoneNumber.prototype, "watchIndex", null);
__decorate([Prop({
  type: Object,
  default: {}
})], PhoneNumber.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], PhoneNumber.prototype, "dataChage", null);
PhoneNumber = __decorate([Component({
  name: "phoneNumber"
})], PhoneNumber);
export default PhoneNumber;